// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3_639","inner":"Form_inner__2bfjL","range":"Form_range__JnfD7","name":"Form_name__4TJFq","actions":"Form_actions__1dRlH"};